<template>
  <div class="page" :style="{ minHeight: pageHeight + 'px' }">
      <iframe style="width:100%;height:500px" src="http://mp.weixin.qq.com/s/D3Of4s6IOKTYlgRwYbSpow" frameborder="0"></iframe>
  </div>
</template>

<script>
import storejs from "store";
import util from "@/libs/util.js";
import moment from "moment";
import { Dialog } from "vant";
import wechatService from "@/services/request/wechatService.js";
import $ from "jquery";
var wx = require("weixin-js-sdk");

export default {
  name: "Claim",
  components: {},
  data() {
    return {
      moment: moment,
      publicData: storejs.get("publicData"),
      pageHeight: window.innerHeight,
    };
  },
  watch: {},
  mounted() {},
  beforeDestroy: function () {},
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
.page {
  //   padding: 0.15rem;
  box-sizing: border-box;
  background: #e7fcee;
  
}
</style>
